import type { ReactNode } from 'react';
import styles from './StatCard.module.css';

interface StatCardProps {
  label: string;
  value: string | number;
  smallValue?: boolean;
  children?: ReactNode;
}

export function StatCard({ label, value, smallValue, children }: StatCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.label}>{label}</div>
      <div className={`${styles.value} ${smallValue ? styles.valueSmall : ''}`}>
        {typeof value === 'number' ? value.toLocaleString() : value}
      </div>
      {children}
    </div>
  );
}

interface TierBreakdownProps {
  free: number;
  pro: number;
  enterprise: number;
}

export function TierBreakdown({ free, pro, enterprise }: TierBreakdownProps) {
  return (
    <div className={styles.breakdown}>
      <div className={styles.breakdownItem}>
        <span className={styles.breakdownLabel}>Free</span>
        <span className={`${styles.breakdownValue} ${styles.breakdownFree}`}>
          {free.toLocaleString()}
        </span>
      </div>
      <div className={styles.breakdownItem}>
        <span className={styles.breakdownLabel}>Pro</span>
        <span className={`${styles.breakdownValue} ${styles.breakdownPro}`}>
          {pro.toLocaleString()}
        </span>
      </div>
      <div className={styles.breakdownItem}>
        <span className={styles.breakdownLabel}>Enterprise</span>
        <span className={`${styles.breakdownValue} ${styles.breakdownEnterprise}`}>
          {enterprise.toLocaleString()}
        </span>
      </div>
    </div>
  );
}

interface MRRBreakdownProps {
  active: number;
  atRisk: number;
  trialPipeline: number;
}

export function MRRBreakdown({ active, atRisk, trialPipeline }: MRRBreakdownProps) {
  return (
    <div className={styles.breakdown}>
      <div className={styles.breakdownItem}>
        <span className={styles.breakdownLabel}>Active</span>
        <span className={`${styles.breakdownValue} ${styles.breakdownActive}`}>
          ${active.toLocaleString()}
        </span>
      </div>
      <div className={styles.breakdownItem}>
        <span className={styles.breakdownLabel}>At Risk</span>
        <span className={`${styles.breakdownValue} ${styles.breakdownAtRisk}`}>
          ${atRisk.toLocaleString()}
        </span>
      </div>
      <div className={styles.breakdownItem}>
        <span className={styles.breakdownLabel}>Trial</span>
        <span className={`${styles.breakdownValue} ${styles.breakdownTrial}`}>
          ${trialPipeline.toLocaleString()}
        </span>
      </div>
    </div>
  );
}
